import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ConnectInstagramDialogComponent } from './connect-instagram-dialog.component'

@Injectable()
export class ConnectInstagramDialogService {
  constructor(private dialog: MatDialog) {}

  public open() {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['fixed-modal', 'no-scroll-modal'],
    }

    return this.dialog.open(ConnectInstagramDialogComponent, defaultConfig)
  }
}
